// OneDrive:IgnoreCodeCoverage

import { createSingleEvent, ISingleEventType, ISingleEvent } from '../SingleEventBase';
import { EventFieldType } from '../IEvent';
import { Trace, ITraceSingleSchema } from './Trace.event';
export interface IVerboseSingleSchema extends ITraceSingleSchema {
    /**
     * This is the name of the qos event this verbose log correlates with
     */
    name?: string;
}

export interface IVerbose extends ISingleEvent<IVerboseSingleSchema> {
    data: IVerboseSingleSchema;
}

export type Verbose = IVerbose;

export const Verbose: IVerboseType = createSingleEvent<IVerboseSingleSchema>({
    eventName: 'Verbose,Trace,',
    shortEventName: 'Verbose',
    requiresParent: false
}, {
        name: {
            isKey: true,
            type: EventFieldType.String
        }
    }, Trace);

export interface IVerboseType extends ISingleEventType<IVerboseSingleSchema> {
}
